module.exports = __webpack_public_path__ + "media/images/logos/logo_edone-89ceb3e97190e68a07e61ccaf3fdcf2b.svg";